import React from 'react';

import { Alert, FormGroup, SubmitModal, UploadFileButton } from '../';
import _ from '../../locale';
import renderErrors from '../../utility/renderErrors';

type Props = {
    emails: string[];
    isVisible: boolean;
    onClose: () => void;
    onInvite: () => void;
    onUploadFile: (event: any) => void;
    errors: { fields: any } | null;
    isFileSelected: boolean;
    isSubmittable: boolean;
    isSubmitting: boolean;
    successMessage: string | null;
};

export default class BulkInviteAccountView extends React.Component<Props> {
    render() {
        const {
            emails,
            isVisible,
            onClose,
            onInvite,
            errors,
            onUploadFile,
            isFileSelected,
            isSubmittable,
            isSubmitting,
            successMessage,
        } = this.props;

        return (
            <SubmitModal
                title={_('bulk_invite_modal_title')}
                submitLabel={_('bulk_invite_modal_invite')}
                isVisible={isVisible}
                onClose={onClose}
                onSubmit={onInvite}
                isSubmitting={isSubmitting}
                isSaveDisabled={!isSubmittable}
            >
                {successMessage && (
                    <FormGroup>
                        <Alert color="success">{successMessage}</Alert>
                    </FormGroup>
                )}
                {errors && (
                    <FormGroup>
                        <Alert color="error" direction="column">
                            {renderErrors(errors)}
                        </Alert>
                    </FormGroup>
                )}
                {isFileSelected && !errors && (
                    <FormGroup>
                        <Alert color="warning">
                            <p>
                                {_('bulk_invite_modal_successful_upload')}{' '}
                                <b>{_('bulk_invite_modal_overwrite_warning')}</b>
                            </p>
                        </Alert>
                    </FormGroup>
                )}

                <FormGroup>{_('bulk_invite_modal_description')}</FormGroup>

                <FormGroup>
                    <UploadFileButton
                        label={
                            isFileSelected
                                ? _('bulk_invite_modal_upload_new')
                                : _('bulk_invite_modal_choose_file')
                        }
                        onUploadFile={onUploadFile}
                    />
                </FormGroup>

                {isFileSelected && !errors && emails && emails.length && (
                    <FormGroup>
                        <b>{_('bulk_invite_modal_confirm_inviting')}</b>
                        <ul>
                            {emails.map((email) => (
                                <li key={email}>{email}</li>
                            ))}
                        </ul>
                    </FormGroup>
                )}
            </SubmitModal>
        );
    }
}
